// Major US cities with population > ~100k, used for map orientation labels
// [name, stateCode, lat, lng, population (approx)]
export interface MajorCity {
  name: string;
  state: string;
  lat: number;
  lng: number;
  pop: number;
}

export const MAJOR_CITIES: MajorCity[] = [
  // California
  { name: 'Los Angeles', state: 'CA', lat: 34.0522, lng: -118.2437, pop: 3900000 },
  { name: 'San Diego', state: 'CA', lat: 32.7157, lng: -117.1611, pop: 1420000 },
  { name: 'San Jose', state: 'CA', lat: 37.3382, lng: -121.8863, pop: 1030000 },
  { name: 'San Francisco', state: 'CA', lat: 37.7749, lng: -122.4194, pop: 870000 },
  { name: 'Fresno', state: 'CA', lat: 36.7378, lng: -119.7871, pop: 540000 },
  { name: 'Sacramento', state: 'CA', lat: 38.5816, lng: -121.4944, pop: 520000 },
  { name: 'Long Beach', state: 'CA', lat: 33.7701, lng: -118.1937, pop: 470000 },
  { name: 'Oakland', state: 'CA', lat: 37.8044, lng: -122.2712, pop: 430000 },
  { name: 'Bakersfield', state: 'CA', lat: 35.3733, lng: -119.0187, pop: 400000 },
  { name: 'Anaheim', state: 'CA', lat: 33.8366, lng: -117.9143, pop: 350000 },
  { name: 'Riverside', state: 'CA', lat: 33.9533, lng: -117.3962, pop: 330000 },
  { name: 'Santa Ana', state: 'CA', lat: 33.7455, lng: -117.8677, pop: 310000 },
  { name: 'Stockton', state: 'CA', lat: 37.9577, lng: -121.2908, pop: 310000 },
  { name: 'Irvine', state: 'CA', lat: 33.6846, lng: -117.8265, pop: 300000 },
  { name: 'San Bernardino', state: 'CA', lat: 34.1083, lng: -117.2898, pop: 220000 },
  { name: 'Modesto', state: 'CA', lat: 37.6391, lng: -120.9969, pop: 210000 },
  { name: 'Santa Rosa', state: 'CA', lat: 38.4404, lng: -122.7141, pop: 180000 },
  { name: 'Redding', state: 'CA', lat: 40.5865, lng: -122.3917, pop: 92000 },
  { name: 'Palm Springs', state: 'CA', lat: 33.8303, lng: -116.5453, pop: 48000 },
  // Texas
  { name: 'Houston', state: 'TX', lat: 29.7604, lng: -95.3698, pop: 2300000 },
  { name: 'San Antonio', state: 'TX', lat: 29.4241, lng: -98.4936, pop: 1530000 },
  { name: 'Dallas', state: 'TX', lat: 32.7767, lng: -96.7970, pop: 1340000 },
  { name: 'Austin', state: 'TX', lat: 30.2672, lng: -97.7431, pop: 1000000 },
  { name: 'Fort Worth', state: 'TX', lat: 32.7555, lng: -97.3308, pop: 920000 },
  { name: 'El Paso', state: 'TX', lat: 31.7619, lng: -106.4850, pop: 680000 },
  { name: 'Corpus Christi', state: 'TX', lat: 27.8006, lng: -97.3964, pop: 320000 },
  { name: 'Lubbock', state: 'TX', lat: 33.5779, lng: -101.8552, pop: 260000 },
  { name: 'Amarillo', state: 'TX', lat: 35.2220, lng: -101.8313, pop: 200000 },
  { name: 'Midland', state: 'TX', lat: 31.9973, lng: -102.0779, pop: 140000 },
  // Florida
  { name: 'Jacksonville', state: 'FL', lat: 30.3322, lng: -81.6557, pop: 950000 },
  { name: 'Miami', state: 'FL', lat: 25.7617, lng: -80.1918, pop: 470000 },
  { name: 'Tampa', state: 'FL', lat: 27.9506, lng: -82.4572, pop: 400000 },
  { name: 'Orlando', state: 'FL', lat: 28.5383, lng: -81.3792, pop: 310000 },
  { name: 'St. Petersburg', state: 'FL', lat: 27.7676, lng: -82.6403, pop: 260000 },
  { name: 'Fort Lauderdale', state: 'FL', lat: 26.1224, lng: -80.1373, pop: 180000 },
  { name: 'Tallahassee', state: 'FL', lat: 30.4383, lng: -84.2807, pop: 195000 },
  { name: 'Pensacola', state: 'FL', lat: 30.4213, lng: -87.2169, pop: 53000 },
  // New York
  { name: 'New York City', state: 'NY', lat: 40.7128, lng: -74.0060, pop: 8340000 },
  { name: 'Buffalo', state: 'NY', lat: 42.8864, lng: -78.8784, pop: 280000 },
  { name: 'Rochester', state: 'NY', lat: 43.1566, lng: -77.6088, pop: 210000 },
  { name: 'Albany', state: 'NY', lat: 42.6526, lng: -73.7562, pop: 100000 },
  { name: 'Syracuse', state: 'NY', lat: 43.0481, lng: -76.1474, pop: 150000 },
  // Pennsylvania
  { name: 'Philadelphia', state: 'PA', lat: 39.9526, lng: -75.1652, pop: 1600000 },
  { name: 'Pittsburgh', state: 'PA', lat: 40.4406, lng: -79.9959, pop: 300000 },
  { name: 'Allentown', state: 'PA', lat: 40.6084, lng: -75.4902, pop: 125000 },
  { name: 'Harrisburg', state: 'PA', lat: 40.2732, lng: -76.8867, pop: 50000 },
  // Illinois
  { name: 'Chicago', state: 'IL', lat: 41.8781, lng: -87.6298, pop: 2700000 },
  { name: 'Aurora', state: 'IL', lat: 41.7606, lng: -88.3201, pop: 200000 },
  { name: 'Rockford', state: 'IL', lat: 42.2711, lng: -89.0940, pop: 150000 },
  { name: 'Springfield', state: 'IL', lat: 39.7817, lng: -89.6501, pop: 115000 },
  // Ohio
  { name: 'Columbus', state: 'OH', lat: 39.9612, lng: -82.9988, pop: 900000 },
  { name: 'Cleveland', state: 'OH', lat: 41.4993, lng: -81.6944, pop: 380000 },
  { name: 'Cincinnati', state: 'OH', lat: 39.1031, lng: -84.5120, pop: 310000 },
  { name: 'Toledo', state: 'OH', lat: 41.6528, lng: -83.5379, pop: 270000 },
  { name: 'Akron', state: 'OH', lat: 41.0814, lng: -81.5190, pop: 190000 },
  // Georgia
  { name: 'Atlanta', state: 'GA', lat: 33.7490, lng: -84.3880, pop: 500000 },
  { name: 'Augusta', state: 'GA', lat: 33.4735, lng: -82.0105, pop: 200000 },
  { name: 'Savannah', state: 'GA', lat: 32.0809, lng: -81.0912, pop: 150000 },
  // Michigan
  { name: 'Detroit', state: 'MI', lat: 42.3314, lng: -83.0458, pop: 670000 },
  { name: 'Grand Rapids', state: 'MI', lat: 42.9634, lng: -85.6681, pop: 200000 },
  { name: 'Lansing', state: 'MI', lat: 42.7325, lng: -84.5555, pop: 120000 },
  // North Carolina
  { name: 'Charlotte', state: 'NC', lat: 35.2271, lng: -80.8431, pop: 880000 },
  { name: 'Raleigh', state: 'NC', lat: 35.7796, lng: -78.6382, pop: 470000 },
  { name: 'Greensboro', state: 'NC', lat: 36.0726, lng: -79.7920, pop: 300000 },
  // New Jersey
  { name: 'Newark', state: 'NJ', lat: 40.7357, lng: -74.1724, pop: 310000 },
  { name: 'Jersey City', state: 'NJ', lat: 40.7178, lng: -74.0431, pop: 290000 },
  { name: 'Trenton', state: 'NJ', lat: 40.2171, lng: -74.7429, pop: 90000 },
  // Virginia
  { name: 'Virginia Beach', state: 'VA', lat: 36.8529, lng: -75.9780, pop: 460000 },
  { name: 'Norfolk', state: 'VA', lat: 36.8508, lng: -76.2859, pop: 240000 },
  { name: 'Richmond', state: 'VA', lat: 37.5407, lng: -77.4360, pop: 230000 },
  // Washington
  { name: 'Seattle', state: 'WA', lat: 47.6062, lng: -122.3321, pop: 740000 },
  { name: 'Spokane', state: 'WA', lat: 47.6588, lng: -117.4260, pop: 230000 },
  { name: 'Tacoma', state: 'WA', lat: 47.2529, lng: -122.4443, pop: 220000 },
  // Arizona
  { name: 'Phoenix', state: 'AZ', lat: 33.4484, lng: -112.0740, pop: 1630000 },
  { name: 'Tucson', state: 'AZ', lat: 32.2226, lng: -110.9747, pop: 540000 },
  { name: 'Mesa', state: 'AZ', lat: 33.4152, lng: -111.8315, pop: 500000 },
  { name: 'Flagstaff', state: 'AZ', lat: 35.1983, lng: -111.6513, pop: 75000 },
  // Colorado
  { name: 'Denver', state: 'CO', lat: 39.7392, lng: -104.9903, pop: 720000 },
  { name: 'Colorado Springs', state: 'CO', lat: 38.8339, lng: -104.8214, pop: 480000 },
  { name: 'Aurora', state: 'CO', lat: 39.7294, lng: -104.8319, pop: 390000 },
  // Massachusetts
  { name: 'Boston', state: 'MA', lat: 42.3601, lng: -71.0589, pop: 690000 },
  { name: 'Worcester', state: 'MA', lat: 42.2626, lng: -71.8023, pop: 205000 },
  { name: 'Springfield', state: 'MA', lat: 42.1015, lng: -72.5898, pop: 155000 },
  // Tennessee
  { name: 'Nashville', state: 'TN', lat: 36.1627, lng: -86.7816, pop: 690000 },
  { name: 'Memphis', state: 'TN', lat: 35.1495, lng: -90.0490, pop: 630000 },
  { name: 'Knoxville', state: 'TN', lat: 35.9606, lng: -83.9207, pop: 190000 },
  { name: 'Chattanooga', state: 'TN', lat: 35.0456, lng: -85.3097, pop: 180000 },
  // Indiana
  { name: 'Indianapolis', state: 'IN', lat: 39.7684, lng: -86.1581, pop: 880000 },
  { name: 'Fort Wayne', state: 'IN', lat: 41.0793, lng: -85.1394, pop: 270000 },
  { name: 'South Bend', state: 'IN', lat: 41.6764, lng: -86.2520, pop: 100000 },
  // Missouri
  { name: 'Kansas City', state: 'MO', lat: 39.0997, lng: -94.5786, pop: 510000 },
  { name: 'St. Louis', state: 'MO', lat: 38.6270, lng: -90.1994, pop: 300000 },
  { name: 'Springfield', state: 'MO', lat: 37.2090, lng: -93.2923, pop: 170000 },
  // Maryland
  { name: 'Baltimore', state: 'MD', lat: 39.2904, lng: -76.6122, pop: 580000 },
  // Wisconsin
  { name: 'Milwaukee', state: 'WI', lat: 43.0389, lng: -87.9065, pop: 580000 },
  { name: 'Madison', state: 'WI', lat: 43.0731, lng: -89.4012, pop: 260000 },
  { name: 'Green Bay', state: 'WI', lat: 44.5133, lng: -88.0133, pop: 105000 },
  // Minnesota
  { name: 'Minneapolis', state: 'MN', lat: 44.9778, lng: -93.2650, pop: 430000 },
  { name: 'St. Paul', state: 'MN', lat: 44.9537, lng: -93.0900, pop: 310000 },
  { name: 'Duluth', state: 'MN', lat: 46.7867, lng: -92.1005, pop: 90000 },
  // Louisiana
  { name: 'New Orleans', state: 'LA', lat: 29.9511, lng: -90.0715, pop: 390000 },
  { name: 'Baton Rouge', state: 'LA', lat: 30.4515, lng: -91.1871, pop: 230000 },
  { name: 'Shreveport', state: 'LA', lat: 32.5252, lng: -93.7502, pop: 190000 },
  // Alabama
  { name: 'Birmingham', state: 'AL', lat: 33.5186, lng: -86.8104, pop: 200000 },
  { name: 'Montgomery', state: 'AL', lat: 32.3792, lng: -86.3077, pop: 200000 },
  { name: 'Mobile', state: 'AL', lat: 30.6954, lng: -88.0399, pop: 190000 },
  { name: 'Huntsville', state: 'AL', lat: 34.7304, lng: -86.5861, pop: 215000 },
  // South Carolina
  { name: 'Charleston', state: 'SC', lat: 32.7765, lng: -79.9311, pop: 150000 },
  { name: 'Columbia', state: 'SC', lat: 34.0007, lng: -81.0348, pop: 130000 },
  { name: 'Greenville', state: 'SC', lat: 34.8526, lng: -82.3940, pop: 70000 },
  // Kentucky
  { name: 'Louisville', state: 'KY', lat: 38.2527, lng: -85.7585, pop: 630000 },
  { name: 'Lexington', state: 'KY', lat: 38.0406, lng: -84.5037, pop: 320000 },
  // Oregon
  { name: 'Portland', state: 'OR', lat: 45.5152, lng: -122.6784, pop: 650000 },
  { name: 'Eugene', state: 'OR', lat: 44.0521, lng: -123.0868, pop: 175000 },
  { name: 'Salem', state: 'OR', lat: 44.9429, lng: -123.0351, pop: 175000 },
  // Oklahoma
  { name: 'Oklahoma City', state: 'OK', lat: 35.4676, lng: -97.5164, pop: 680000 },
  { name: 'Tulsa', state: 'OK', lat: 36.1540, lng: -95.9928, pop: 400000 },
  // Connecticut
  { name: 'Bridgeport', state: 'CT', lat: 41.1865, lng: -73.1952, pop: 150000 },
  { name: 'Hartford', state: 'CT', lat: 41.7658, lng: -72.6734, pop: 120000 },
  { name: 'New Haven', state: 'CT', lat: 41.3083, lng: -72.9279, pop: 135000 },
  // Iowa
  { name: 'Des Moines', state: 'IA', lat: 41.5868, lng: -93.6250, pop: 215000 },
  { name: 'Cedar Rapids', state: 'IA', lat: 41.9779, lng: -91.6656, pop: 135000 },
  // Mississippi
  { name: 'Jackson', state: 'MS', lat: 32.2988, lng: -90.1848, pop: 150000 },
  // Arkansas
  { name: 'Little Rock', state: 'AR', lat: 34.7465, lng: -92.2896, pop: 200000 },
  // Kansas
  { name: 'Wichita', state: 'KS', lat: 37.6872, lng: -97.3301, pop: 400000 },
  { name: 'Kansas City', state: 'KS', lat: 39.1142, lng: -94.6275, pop: 155000 },
  // Nevada
  { name: 'Las Vegas', state: 'NV', lat: 36.1699, lng: -115.1398, pop: 650000 },
  { name: 'Reno', state: 'NV', lat: 39.5296, lng: -119.8138, pop: 265000 },
  // Utah
  { name: 'Salt Lake City', state: 'UT', lat: 40.7608, lng: -111.8910, pop: 200000 },
  { name: 'Provo', state: 'UT', lat: 40.2338, lng: -111.6585, pop: 115000 },
  // Nebraska
  { name: 'Omaha', state: 'NE', lat: 41.2565, lng: -95.9345, pop: 490000 },
  { name: 'Lincoln', state: 'NE', lat: 40.8136, lng: -96.7026, pop: 290000 },
  // New Mexico
  { name: 'Albuquerque', state: 'NM', lat: 35.0844, lng: -106.6504, pop: 560000 },
  { name: 'Santa Fe', state: 'NM', lat: 35.6870, lng: -105.9378, pop: 90000 },
  { name: 'Las Cruces', state: 'NM', lat: 32.3199, lng: -106.7637, pop: 110000 },
  // West Virginia
  { name: 'Charleston', state: 'WV', lat: 38.3498, lng: -81.6326, pop: 47000 },
  // Idaho
  { name: 'Boise', state: 'ID', lat: 43.6150, lng: -116.2023, pop: 230000 },
  // Hawaii
  { name: 'Honolulu', state: 'HI', lat: 21.3069, lng: -157.8583, pop: 350000 },
  // Maine
  { name: 'Portland', state: 'ME', lat: 43.6591, lng: -70.2568, pop: 68000 },
  // New Hampshire
  { name: 'Manchester', state: 'NH', lat: 42.9956, lng: -71.4548, pop: 115000 },
  // Montana
  { name: 'Billings', state: 'MT', lat: 45.7833, lng: -108.5007, pop: 120000 },
  { name: 'Missoula', state: 'MT', lat: 46.8721, lng: -114.0131, pop: 75000 },
  // Alaska
  { name: 'Anchorage', state: 'AK', lat: 61.2181, lng: -149.9003, pop: 290000 },
  // Rhode Island
  { name: 'Providence', state: 'RI', lat: 41.8240, lng: -71.4128, pop: 190000 },
  // Delaware
  { name: 'Wilmington', state: 'DE', lat: 39.7391, lng: -75.5398, pop: 70000 },
  // South Dakota
  { name: 'Sioux Falls', state: 'SD', lat: 43.5446, lng: -96.7311, pop: 195000 },
  // North Dakota
  { name: 'Fargo', state: 'ND', lat: 46.8772, lng: -96.7898, pop: 125000 },
  // Vermont
  { name: 'Burlington', state: 'VT', lat: 44.4759, lng: -73.2121, pop: 45000 },
  // Wyoming
  { name: 'Cheyenne', state: 'WY', lat: 41.1400, lng: -104.8202, pop: 65000 },
  // Washington DC
  { name: 'Washington', state: 'DC', lat: 38.9072, lng: -77.0369, pop: 710000 },
];

// Get cities for a specific state, sorted by population (largest first)
export function getCitiesForState(stateCode: string): MajorCity[] {
  return MAJOR_CITIES
    .filter(c => c.state === stateCode)
    .sort((a, b) => b.pop - a.pop);
}
